module.exports = __webpack_public_path__ + "img/kh.345dd2ea.svg";